import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtn,{staticClass:"ml-n3 ma-1 appbutton rounded-lg white--text font-weight-medium",attrs:{"elevation":"6","large":"","block":"","color":"#B22AF0","z-index":"12"},on:{"click":function($event){return _vm.InitiatePaymentRequest()}}},[_vm._v("\n    Verify & Accept")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }